/** Floating input style — white background, subtle shadow, no outline border. */
export const floatingInputSx = {
  "& .MuiInputBase-root": {
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    boxShadow: "0 3px 10px rgb(0 0 0 / 15%)",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}
